module.exports = __webpack_public_path__ + "media/images/div_lens/Step1-efbf02bece8860b8e886c444b460557a.png";